import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterLink, RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { CurrentSubscriptionService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { RmaLetModule } from '@rma/dashboard/generic/ui/let';
import { ValidationService } from '@rma/dashboard/generic/util/validation';
import { NavigationHeaderComponent } from '@rma/dashboard/layout/public/navigation-header';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { exhaustMap, filter, Observable, take, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'rma-call-before-unsubscribe',
  templateUrl: './call-before-unsubscribe.component.html',
  styleUrls: ['./call-before-unsubscribe.component.scss'],
  imports: [
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    NavigationHeaderComponent,
    ReactiveFormsModule,
    RmaIconComponent,
    RmaIconComponent,
    RmaLetModule,
    RouterLink,
    RouterModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideTranslocoScope('subscriptions')],
})
export class CallBeforeUnsubscribeComponent {
  public formSubmitted = false;
  public contactForm: UntypedFormGroup;
  public submitting = false;

  public isAgency$: Observable<boolean>;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly currentSubscriptionService: CurrentSubscriptionService,
    private readonly profileUserService: DashboardProfileContextService,
    private readonly validationService: ValidationService,
  ) {
    this.contactForm = new UntypedFormGroup({
      contactName: new UntypedFormControl('', [Validators.required]),
      phoneNo: new UntypedFormControl('', [Validators.required]),
    });

    this.isAgency$ = this.profileUserService.isAgency$;
  }

  public onRequestCancellation(): void {
    this.profileUserService.isAgency$
      .pipe(
        filter((isAgency) => !isAgency || !this.contactForm.invalid),
        tap((_) => (this.submitting = true)),
        exhaustMap(() =>
          this.currentSubscriptionService.requestCancellation(
            this.contactForm.get('contactName')?.value,
            this.contactForm.get('phoneNo')?.value,
          ),
        ),
        take(1),
      )
      .subscribe({
        next: () => {
          this.submitting = false;
          this.formSubmitted = true;
          this.cdRef.markForCheck();
        },
        error: (response) => {
          this.submitting = false;
          // this.errorMessages = this.validationService.handleAPIErrorBasic(response.data);
          this.cdRef.markForCheck();
        },
      });
  }
}
